module.exports = __webpack_public_path__ + "img/政企.e4817aca.png";